export default "__VITE_ASSET__Ba_dtZ1Y__"